import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <h1 className="text-8xl font-bold text-[var(--color-primary)] mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-3">Between dimensions</h2>
        <p className="text-gray-400 mb-8">
          The body you were looking for doesn't exist at this address.
          Try a body signal instead, or head back to the vault.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/discover"
            className="px-6 py-3 rounded-lg border border-emerald-300/40 bg-emerald-300/5 text-emerald-100 transition hover:border-emerald-300/70 hover:bg-emerald-300/10"
          >
            Pick a body signal
          </Link>
          <Link
            to="/"
            className="btn-primary px-6 py-3 rounded-lg"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
